import { createPosition } from "@shared/common/utils/create";
import shortUUID from "short-uuid";
import type { IFormFileUploaderNode, PartialNode } from "../type";

const createFormFileUploaderNode = (
  data?: PartialNode<IFormFileUploaderNode>
): IFormFileUploaderNode => {
  return {
    type: "FORM_FILE_UPLOADER",
    id: shortUUID.generate(),
    pluginData: {
      contentEditorPropSeq: 0,
      contentMeta: [],
    },
    reactions: [],
    position: createPosition(data?.position),

    name: "",

    width: { value: 100, unit: "%" },

    fills: [],

    locked: false,

    strokes: [],
    strokeWeight: 1,
    strokeAlign: "CENTER",
    strokeCap: "SQUARE",
    strokeJoin: "ROUND",
    dashPattern: [],

    visible: true,

    effects: [],

    label: "<p>파일 업로드</p>",
    required: false,

    maxFileCount: 1,

    ...data,
  };
};

export default createFormFileUploaderNode;
